export const formatExternalProjectName = (project, getSd) => {
    if(project?.configuration?.useExternalProject){
        let keys = project?.configuration?.externalProject?.surveyDatasKeysUsed
        let srv = getSd?.survey?.externalProjectData
        let formatResponseData = srv ? keys?.map(k => srv[k]?.value)?.join(" ") : null
        
        return formatResponseData
    }
}